import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MenuGroup } from '../../../services/menu-group.service';

@Component({
    selector: 'app-delete-menu-group-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule],
    templateUrl: './delete-menu-group-dialog.component.html',
    styleUrl: './delete-menu-group-dialog.component.scss',
})
export class DeleteMenuGroupDialogComponent {
    constructor(
        // eslint-disable-next-line no-unused-vars
        public dialogRef: MatDialogRef<DeleteMenuGroupDialogComponent>,
        // eslint-disable-next-line no-unused-vars
        @Inject(MAT_DIALOG_DATA) public data: { menuGroup: MenuGroup }
    ) {}

    onConfirm(): void {
        this.dialogRef.close(true);
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }
}
